import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import Immutable from "immutable";
import { themeOptions } from "styles/theme";
import Bottom from "./bottom";
import { toDataTest } from "helpers/test";
import { merge, $ } from "glamor";
import {
    Badge,
    Collapse,
    LinearProgress,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Tooltip,
} from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { DefaultCheckbox } from "components/form/checkbox";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import InfoIcon from "@material-ui/icons/Info";
import { isEmpty } from "lodash";

const NONE_SELECTED = "none";
const SOME_SELECTED = "some";
const ALL_SELECTED = "all";

const Loading = () => {
    return (
        <div style={{ margin: "0 16px" }}>
            <LinearProgress key="loading" mode="indeterminate" />
        </div>
    );
};

class SelectFilter extends PureComponent {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        filter: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
        filterKey: PropTypes.string,
        parentValue: PropTypes.string,
        parentFilter: PropTypes.object,
        parentKey: PropTypes.string,
        // All active values for all filters, it is the filter's responsibility to get/set it's values
        activeFiltersValues: PropTypes.instanceOf(Immutable.Map).isRequired,
        activeFilterValues: PropTypes.instanceOf(Immutable.List),
        valuesByDepth: PropTypes.array,
        depth: PropTypes.number,
        lastFilter: PropTypes.bool,
        filtersDisabled: PropTypes.bool,
        onFetchData: PropTypes.func,
    };

    static defaultProps = {
        depth: 0,
        lastFilter: false,
        activeFilterValues: Immutable.List(),
    };

    styles = {
        listOpen: {
            backgroundColor: "white",
        },
        nestedListItem: {
            backgroundColor: "transparent",
        },
        list: {
            paddingLeft: "14px",
            paddingRight: "12px",
        },
        listNested: {
            paddingTop: 0,
            paddingBottom: 0,
        },
        listItem: {
            fontSize: "14px",
            margin: 0,
            padding: "3px 16px 3px 8px",
            color: themeOptions.palette.darkerGrey,
        },
        listItemNested: {
            padding: "8px 4px",
            color: themeOptions.palette.darkGrey,
        },
        dropdownIcon: {
            fontSize: "24px",
            color: "#757575",
            transition: "transform .1s",
        },
        dropdownIconOpen: {
            msTransform: "rotate(-90deg)",
            WebkitTransform: "rotate(-90deg)",
            transform: "rotate(-90deg)",
        },
        groupCheckbox: {
            zIndex: 3,
        },
        badgeContainer: merge(
            {
                position: "relative",
                width: "90%",
            },
            $(" .MuiBadge-root", {
                position: "static",
                padding: "0px",
            }),
            $(" .MuiBadge-badge", {
                top: 10,
                fontSize: "12px",
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                color: themeOptions.palette.darkerGrey,
                backgroundColor: themeOptions.palette.lightGrey,
                fontFamily: "Lato, sans-serif",
            }),
        ),
        bottom: {
            height: "8px",
        },
        label: {
            fontSize: "14px",
            fontFamily: "Lato, sans-serif",
            color: themeOptions.palette.textColor,
            display: "inherit",
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
        checkboxWrapper: {
            minWidth: "24px",
            marginRight: "20px",
        },
    };

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            filterKey: props.filterKey,
            valuesByDepth: props.valuesByDepth,
            activeFilterValues: props.activeFilterValues,
        };

        this.handleCheck = this.handleCheck.bind(this);
        this.handleGroupCheck = this.handleGroupCheck.bind(this);
        this.handleToggleOpen = this.handleToggleOpen.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { filter, depth, activeFiltersValues, filterKey, onFetchData } = this.props;
        const { valuesByDepth } = this.state;
        const isLeaf = !Array.isArray(filter.__data) && !filter.__lookup && depth > 0;
        this.setState({ isLeaf });

        if (!isLeaf && depth > 0) {
            const keys = filterKey.split("::");
            this.setState({
                groupKey: keys.splice(depth - 1, keys.length - depth).join("::"),
            });
        }

        // computer initial open, assumption all filters have same nesting
        if (depth === 0) {
            let key = filter.__key;
            let nestedFilter = filter;
            while (nestedFilter.__data.length && nestedFilter.__data[0]?.__data) {
                nestedFilter = nestedFilter.__data[0];
                const subkey = nestedFilter.__key;
                key = key + "::" + subkey;
            }

            let values = activeFiltersValues.get(filter.__filterKey || key);

            const slicedValues = [];
            if (values) {
                if (typeof values === "string") {
                    values = Immutable.List.of(values);
                }

                values.forEach((value) => {
                    value.split("::").forEach((part, i) => {
                        slicedValues[i] = slicedValues[i] || [];
                        slicedValues[i].push(part);
                    });
                });
            } else {
                values = Immutable.List();
            }

            this.setState({
                filterKey: filter.__filterKey || key,
                valuesByDepth: slicedValues,
                activeFilterValues: values,
                open: Boolean(values.size || filter.__initiallyOpen || filter.__default_open),
            });

            if (filter.__loaded === false && filter.__fetching === false && values.size) {
                onFetchData({ filter });
            }
        } else if (!isLeaf) {
            if (valuesByDepth && valuesByDepth[depth - 1]) {
                this.setState({
                    open: valuesByDepth[depth - 1].indexOf(filter.__value) !== -1,
                });

                if (
                    valuesByDepth[depth - 1].indexOf(filter.__value) !== -1 &&
                    filter.__loaded === false &&
                    filter.__fetching === false
                ) {
                    onFetchData({ filter });
                }
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.depth === 0 && nextProps.activeFiltersValues !== this.props.activeFiltersValues) {
            let values = nextProps.activeFiltersValues.get(this.state.filterKey);

            if (this.state.activeFilterValues !== values) {
                if (typeof values === "string") {
                    values = Immutable.List.of(values);
                } else if (!values) {
                    values = Immutable.List();
                }
                this.setState({ activeFilterValues: values });
            }
        } else if (nextProps.depth !== 0 && nextProps.activeFilterValues !== this.props.activeFilterValues) {
            this.setState({ activeFilterValues: nextProps.activeFilterValues });
        }
    }

    handleToggleOpen() {
        const { onFetchData, filter } = this.props;
        const open = !this.state.open;
        this.setState({ open });
        if (onFetchData && filter.__loaded === false && filter.__fetching === false) {
            onFetchData({
                filter,
            });
        }
    }

    removeChildrenValues(activeFilterValues, parentFilter) {
        let { filter } = this.props;
        if (parentFilter) {
            filter = parentFilter;
        }
        const match = filter.__value + (filter.__topLevelFieldSupport ? "" : "::");
        return activeFilterValues.filter((activeValue) => {
            return activeValue && activeValue.indexOf(match) !== 0;
        });
    }

    addChildrenValues(activeFilterValues, parentFilter, force) {
        activeFilterValues = this.removeChildrenValues(activeFilterValues);
        let { filter } = this.props;
        if (parentFilter) {
            filter = parentFilter;
        }
        if (filter.__topLevelFieldSupport && !force) {
            activeFilterValues = activeFilterValues.push(filter.__value);
        } else {
            if (!parentFilter) {
                activeFilterValues = activeFilterValues.push(filter.__value);
            } else {
                filter.__data.forEach((subfilter) => {
                    activeFilterValues = activeFilterValues.push(
                        filter.__value + "::" + (subfilter.__value || subfilter),
                    );
                });
            }
        }

        return activeFilterValues;
    }

    childrenSelectedState(activeFilterValues, parentFilter) {
        let { filter } = this.props;
        if (parentFilter) {
            filter = parentFilter;
        }
        if (activeFilterValues.includes(filter.__value)) {
            return ALL_SELECTED;
        } else if (filter.__data.length === 0) {
            if (filter.__lookup) {
                const partialMatch = filter.__value + "::";
                const matches = activeFilterValues.some((activeFilter) => activeFilter.indexOf(partialMatch) === 0);
                if (matches) {
                    return SOME_SELECTED;
                }
            }
            return NONE_SELECTED;
        }
        let selectionCount = 0;
        for (let i = 0; i < filter.__data.length; i++) {
            // Can exit early if we know its not posible every is selected
            if (selectionCount > 0 && i !== selectionCount) {
                return SOME_SELECTED;
            }
            const subfilter = filter.__data[i];
            const includes = activeFilterValues.includes(filter.__value + "::" + (subfilter.__value || subfilter));

            if (includes) {
                selectionCount = selectionCount + 1;
            }
        }

        if (selectionCount === 0) {
            return NONE_SELECTED;
        }

        return selectionCount === filter.__data.length ? ALL_SELECTED : SOME_SELECTED;
    }

    updateActiveFilterValuesWithChildren({ activeFilterValues, parentFilter, filter, filterKey }) {
        activeFilterValues = activeFilterValues.filter((val) => val !== parentFilter.__value);

        const filterValue = filter?.__filterKey || filter?.__value || filter?.__key || filter;
        parentFilter.__data.forEach((sub) => {
            const value = sub?.__filterKey || sub?.__value || sub?.__key || sub;
            if (value !== filterValue) {
                activeFilterValues = activeFilterValues.push(
                    sub?.__filterKey || (parentFilter.__value || filterKey) + "::" + value,
                );
            }
        });
        return activeFilterValues;
    }

    setOnlyTopLevelValue() {}

    handleCheck(e, isChecked) {
        e.stopPropagation();
        const { onChange, parentValue, parentFilter, filter, filterKey } = this.props;
        let { activeFilterValues, activeFiltersValues } = this.props;
        let value = filter.__key || filter.__value || filter;
        value = parentValue ? parentValue + "::" + value : value;

        if (isChecked) {
            const selected = activeFilterValues.find((v) => v === value || (v && v.__value === value));
            if (!selected) {
                activeFilterValues = activeFilterValues.push(value);
            }
            if (parentFilter.__topLevelFieldSupport) {
                if (this.childrenSelectedState(activeFilterValues, parentFilter) === ALL_SELECTED) {
                    activeFilterValues = this.removeChildrenValues(activeFilterValues, parentFilter);
                    activeFilterValues = activeFilterValues.push(parentValue);
                }
            }
        } else {
            if (parentFilter.__topLevelFieldSupport) {
                const index = activeFilterValues.indexOf(parentValue);
                if (index !== -1) {
                    // need to select all first
                    activeFilterValues = activeFilterValues.remove(index);

                    activeFilterValues = this.addChildrenValues(activeFilterValues, parentFilter, true);
                }
            }
            activeFilterValues = activeFilterValues.filter((val) => val !== value && val !== undefined);
            const isNested = parentFilter?.__nested || filterKey?.split?.("::")?.length > 1;
            const hasTopLevelValue = activeFilterValues.includes(parentFilter.__value);
            if (isNested && hasTopLevelValue) {
                activeFilterValues = this.updateActiveFilterValuesWithChildren({
                    activeFilterValues,
                    parentFilter,
                    filter,
                    filterKey,
                });
            }
        }

        if (activeFilterValues.size > 0) {
            activeFiltersValues = activeFiltersValues.set(filterKey, activeFilterValues);
        } else {
            activeFiltersValues = activeFiltersValues.delete(filterKey);
        }

        //This might be a nested filter which user has now selected all subvalues.
        // We have to validate that the values are in fact, all of the possible options, not just the length.
        if (parentFilter.__value && parentFilter.__data && parentFilter.__data.length === activeFilterValues.size) {
            const missingSubValues = parentFilter.__data.some((subValue) => {
                return !activeFilterValues.includes(`${parentFilter.__value}::${subValue}`);
            });

            if (!missingSubValues) {
                //remove all subvalues e.g. my_category::my_subcategory and set the top level one instead
                parentFilter.__data.forEach((subValue) => {
                    activeFilterValues = activeFilterValues.filter((value) => {
                        return value !== `${parentFilter.__value}::${subValue}`;
                    });
                });

                activeFilterValues = activeFilterValues.push(parentFilter.__value);
            }

            activeFiltersValues = activeFiltersValues.set(filterKey, activeFilterValues);
        }

        onChange(activeFiltersValues, parentValue, value);
    }

    clearGroupValues({ activeFiltersValues, filterKey, filter }) {
        const values = activeFiltersValues.get(filterKey).filter((val) => val !== filter.__value);

        if (!values.size) {
            activeFiltersValues = activeFiltersValues.delete(filterKey);
        } else {
            activeFiltersValues = activeFiltersValues.set(filterKey, values);
        }

        return activeFiltersValues;
    }

    handleGroupCheck(e, isChecked) {
        e.stopPropagation();

        const { onChange, filterKey, filter } = this.props;
        let { activeFilterValues, activeFiltersValues } = this.props;

        activeFilterValues = isChecked
            ? this.addChildrenValues(activeFilterValues)
            : this.removeChildrenValues(activeFilterValues);
        activeFiltersValues =
            activeFilterValues.size > 0
                ? activeFiltersValues.set(filterKey, activeFilterValues)
                : activeFiltersValues.delete(filterKey);

        const isNested = filter.__nested || filterKey?.split?.("::")?.length > 1;
        const values = activeFiltersValues.get(filterKey);

        if (isNested && values && !isChecked) {
            activeFiltersValues = this.clearGroupValues({ activeFiltersValues, filterKey, filter });
        }

        onChange(activeFiltersValues);
    }

    renderBranch() {
        const { filter, onChange, activeFiltersValues, depth, lastFilter, filtersDisabled, onFetchData } = this.props;
        const { open, filterKey, valuesByDepth, activeFilterValues, groupKey } = this.state;
        const styles = this.styles;
        const childDepth = depth + 1;
        let subcomponents = [];

        if (open) {
            subcomponents = filter?.__data?.filter(Boolean).map((item) => {
                return (
                    <SelectFilter
                        className="selectFilter"
                        key={item.__value || item.__key || item}
                        filterKey={filterKey}
                        parentValue={filter.__value}
                        parentFilter={filter}
                        parentKey={groupKey}
                        filter={item}
                        onChange={onChange}
                        depth={childDepth}
                        onFetchData={onFetchData}
                        activeFiltersValues={activeFiltersValues}
                        activeFilterValues={activeFilterValues}
                        valuesByDepth={valuesByDepth}
                        filtersDisabled={filtersDisabled}
                    />
                );
            });

            if (filter.__loaded === false) {
                subcomponents.push(<Loading key="loading" />);
            } else if (subcomponents.length === 0 && !Array.isArray(filter?.__data)) {
                return null; // Do not show
            }

            if (depth === 0 && !lastFilter) {
                subcomponents.push(<Bottom key={`${filter.__key}-bottom`} style={styles.bottom} />);
            }
        }

        let checkbox;
        if (depth > 0) {
            const selectionState = this.childrenSelectedState(activeFilterValues);
            const checked =
                activeFilterValues.size > 0 && (selectionState === ALL_SELECTED || selectionState === SOME_SELECTED);
            checkbox = (
                <ListItemIcon style={styles.checkboxWrapper}>
                    <DefaultCheckbox
                        style={styles.groupCheckbox}
                        checked={checked}
                        indeterminate={selectionState === SOME_SELECTED}
                        data-test={`checkbox-${toDataTest(filter.__value || filter.__name || filter)}`}
                        onChange={this.handleGroupCheck}
                    />
                </ListItemIcon>
            );
        }
        const itemContent = (
            <span style={styles.label}>{filter.__lookup ? filter.__name : filter.__value || filter.__name}</span>
        );
        // Badge
        let badge = null;
        if (depth === 0 && activeFilterValues.size > 0) {
            badge = (
                <div {...styles.badgeContainer}>
                    <Badge
                        data-test={`filter-${filter.__name.toUpperCase()}-${activeFilterValues.size}`}
                        badgeContent={activeFilterValues.size}
                        color="primary"
                    >
                        {itemContent}
                    </Badge>
                </div>
            );
        }

        return (
            <React.Fragment>
                <ListItem
                    data-test={`filter-${toDataTest(filterKey)}`}
                    className="selectFilter"
                    button
                    onClick={this.handleToggleOpen}
                    style={Object.assign(
                        {},
                        styles.listItem,
                        depth ? styles.listItemNested : {},
                        open && styles.listOpen,
                    )}
                >
                    {checkbox}
                    <ListItemText primary={badge || itemContent} />
                    {!isEmpty(filter?.__data) && (
                        <ChevronLeft
                            data-test={`chevron-${toDataTest(filter.__name)}`}
                            style={Object.assign({}, styles.dropdownIcon, open && styles.dropdownIconOpen)}
                        />
                    )}
                </ListItem>
                <Collapse
                    in={open}
                    unmountOnExit
                    timeout={100}
                    style={Object.assign({}, styles.nestedListItem, open && styles.listOpen)}
                >
                    <List style={{ ...styles.list, ...(depth ? styles.listNested : {}) }}>{subcomponents}</List>
                </Collapse>
            </React.Fragment>
        );
    }

    render() {
        const { isLeaf, filterKey } = this.state;
        return isLeaf ? (
            <Leaf filterKey={filterKey} handleCheck={this.handleCheck} {...this.props} />
        ) : (
            this.renderBranch()
        );
    }
}
export default SelectFilter;

const useLeafStyles = makeStyles({
    listItem: {
        paddingLeft: 16,
        minHeight: "32px",
    },
    tooltip: {
        wordWrap: "break-word",
        whiteSpace: "pre-wrap",
    },
    infoIconStyle: {
        fontSize: "24px",
        color: themeOptions.palette.lightGrey,
    },
    listItemContent: {
        display: "flex",
        width: "100%",
    },
    label: {
        margin: 0,
        paddingLeft: "20px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: themeOptions.palette.textColor,
    },
    listItemIcon: {
        padding: 0,
        minWidth: 0,
    },
});

const Leaf = (props) => {
    const { filter, filterKey, parentValue, depth } = props;
    const { activeFilterValues, filtersDisabled, handleCheck } = props;
    const hasSubFields = Array.isArray(filter.__data);
    const value = hasSubFields ? filter.__value : filter.__key || filter.__value || filter;
    // In case sub filter list is empty display __value as label
    const label = hasSubFields ? filter.__value || filter.__name : filter.__name || value;
    const labelId = `checkbox_label_${value}_${depth}`;
    const classes = useLeafStyles();

    const isChecked = React.useMemo(() => {
        const filterValue = parentValue ? parentValue + "::" + value : value;
        const isActive = !!activeFilterValues.find((v) => v === filterValue || (v && v.__value === filterValue));
        if (parentValue && !isActive) {
            return activeFilterValues.includes(parentValue);
        } else {
            return isActive;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeFilterValues, filter]);

    const itemContent = (
        <label htmlFor={labelId} className={classes.label}>
            {label}
        </label>
    );

    let rightIconButton = null;
    if (filter.__meta && filter.__meta.__tooltip) {
        rightIconButton = (
            <InfoTooltip className={classes.tooltip} title={filter.__meta.__tooltip} placement="top-end">
                <InfoIcon className={classes.infoIconStyle} />
            </InfoTooltip>
        );
    }

    return (
        <ListItem data-test={`subfilter-${toDataTest(value)}`} className={`selectFilter ${classes.listItem}`}>
            <ListItemIcon className={classes.listItemIcon}>
                <DefaultCheckbox
                    id={labelId}
                    edge="start"
                    checked={isChecked}
                    data-test={`checkbox-${toDataTest(filterKey)}-${toDataTest(value)}`}
                    onChange={handleCheck}
                    disabled={filtersDisabled}
                />
            </ListItemIcon>
            <ListItemText primary={itemContent} />
            {rightIconButton}
        </ListItem>
    );
};

const InfoTooltip = withStyles({
    tooltip: {
        maxWidth: 180,
        fontSize: "12px",
    },
})((props) => <Tooltip {...props}>{props.children}</Tooltip>);
